<template>
  <form class="a-filter admin-filter" action="">
    <div class="a-filter__header">
      <h2 v-t="'admin.tenders'">></h2>
    </div>
    <div class="a-filter__body ">
      <div class="a-filter__block admin-filter__block">
        <div class="a-filter__label admin-filter__label">{{$t('form.tender-search.creation-date.label')}}:</div>
        <div class="a-input-group ">
          <p>{{$t('form.tender-search.creation-date.from.label')}}:</p>
          <div class="a-input-group__prepend "><img src="@/assets/img/static/vector.svg" alt=""></div>
          <date-picker v-model="filters.creation.from"></date-picker>
        </div>
        <div class="a-input-group ">
          <p>{{$t('form.tender-search.creation-date.to.label')}}:</p>
          <div class="a-input-group__prepend "><img src="@/assets/img/static/vector.svg" alt=""></div>
          <date-picker v-model="filters.creation.to"></date-picker>
        </div>
      </div>
      <div class="a-filter__block admin-filter__block">
        <div class="a-filter__label admin-filter__label">{{$t('form.tender-search.publish-date.label')}}:</div>
        <div class="a-input-group ">
          <p>{{$t('form.tender-search.publish-date.from.label')}}:</p>
          <div class="a-input-group__prepend "><img src="@/assets/img/static/vector.svg" alt=""></div>
          <date-picker v-model="filters.publication.from"></date-picker>
        </div>
        <div class="a-input-group ">
          <p>{{$t('form.tender-search.publish-date.to.label')}}:</p>
          <div class="a-input-group__prepend "><img src="@/assets/img/static/vector.svg" alt=""></div>
          <date-picker v-model="filters.publication.to"></date-picker>
        </div>
      </div>
      <div class="a-container-form" v-if="currentUser.permissions.IS_MAIN_CUSTOMER_USER">
        <div class="a-label ">{{$t('form.tender-search.owner.label')}}:</div>
        <user-search v-model="filters.owner" class="select-w-260"></user-search>
      </div>
      <div class="a-container-form" v-if="currentUser.permissions.IS_MAIN_CUSTOMER_USER">
        <div class="a-label ">{{$t('form.tender-search.main-owner.label')}}:</div>
        <user-search v-model="filters.mainOwner" class="select-w-260"></user-search>
      </div>
      <div class="a-container-form">
        <div class="a-label ">{{$t('form.tender-search.tender-number.label')}}:</div>
        <input type="text" class="a-input a-input--w-280" v-model="filters.tenderNumber">
      </div>
      <div class="a-container-form">
        <div class="a-label ">{{$t('form.tender-search.tender-subject.label')}}:</div>
        <input type="text" class="a-input a-input--w-380" v-model="filters.tenderSubject"/>
      </div>
      <div class="a-container-form">
        <div class="a-label ">{{$t('form.tender-search.method.label')}}:</div>
        <dropdown-new class="select-w-260"
                      :placeholder="$t('tender-method.empty')"
                      v-model="filters.tenderMethod">
          <option value :label="'tender-method.empty'"></option>
          <option :value="enums.TenderMethod.TENDER" :label="'tender-method.tender'"></option>
          <option :value="enums.TenderMethod.REQUEST_FOR_PRICE" :label="'tender-method.request-for-price'"></option>
          <option :value="enums.TenderMethod.REQUEST_FOR_PROPOSALS" :label="'tender-method.request-for-proposals'"></option>
          <option :value="enums.TenderMethod.ONE" :label="'tender-method.one'"></option>
          <option :value="enums.TenderMethod.REDUCTION" :label="'tender-method.reduction'"></option>
        </dropdown-new>
      </div>
      <div class="a-container-form">
        <div class="a-label ">{{$t('form.tender-search.participation-mode.label')}}:</div>
        <dropdown-new class="select-w-260"
                      :placeholder="$t('tender-participation-mode.empty')"
                      v-model="filters.participationMode">
          <option value :label="'tender-participation-mode.empty'"></option>
          <option :value="enums.TenderParticipationMode.OPEN" :label="'tender-participation-mode.open'"></option>
          <option :value="enums.TenderParticipationMode.CLOSED" :label="'tender-participation-mode.closed'"></option>
        </dropdown-new>
      </div>
    </div>
    <div class="a-filter__footer ">
      <button class="gui-btn gui-btn--red gui-btn--w-278" style="height: 36px" type="button" @click="OnCreateTenderClick" v-if="permissions.CAN_CREATE_LOT">{{$t('buttons.create-tender')}}</button>
      <button class="gui-btn gui-btn--white-border gui-btn--w-167" @click.prevent="resetFilters">{{$t('buttons.reset-filters')}}</button>
      <button class="gui-btn gui-btn--red gui-btn--w-140" type="button" @click="OnApplyClick">{{$t('buttons.apply')}}</button>
    </div>
    <loading v-if="loading"></loading>
  </form>
</template>

<script>
  import UserSearch from '@/components/common/inputs/UserSearch'
  import Currency from '@/api/types/currency'
  import TenderParticipationMode from '@/api/types/tender-participation-mode'
  import TenderMethod from '@/api/types/tender-method'
  import LotCountType from '@/api/types/lot-count-type'
  import _ from 'lodash'

  export default {
    name: "LotsFilters",

    components: {
      UserSearch
    },

    computed: {
      permissions() {
        return this.$store.getters.currentUser.permissions;
      }
    },

    data: () => ({
      loading: false,
      filters: {
        creation: {
          from: undefined,
          to: undefined
        },
        publication: {
          from: undefined,
          to: undefined
        },
        price: {
          from: undefined,
          to: undefined
        },
        owner: undefined,
        mainOwner: undefined,
        currency: undefined,
        tenderMethod: undefined,
        participationMode: undefined,
        lotsCountType: undefined,
        tenderSubject: undefined,
        tenderNumber: undefined
      }
    }),

    methods: {
      async OnApplyClick() {
        this.runAction(async () => {
          try {
            await this.$store.dispatch('fetchTenders', {
              priceFrom: this.filters.price.from,
              priceTo: this.filters.price.to,
              creationDateFrom: this.filters.creation.from,
              creationDateTo: this.filters.creation.to,
              publicationDateFrom: this.filters.publication.from,
              publicationDateTo: this.filters.publication.to,
              currency: this.filters.currency,
              tenderMethod: this.filters.tenderMethod,
              participationMode: this.filters.participationMode,
              lotsCountType: this.filters.lotsCountType,
              owner: _.get(this.filters.owner, 'id'),
              mainOwner: _.get(this.filters.mainOwner, 'id'),
              tenderSubject: this.filters.tenderSubject,
              tenderNumber: this.filters.tenderNumber
            })
          }
          catch (e) {
            console.error('unable to fetch list of tenders', e);
            this.globalErrorHandler(e);
          }
        });
      },

      async OnCreateTenderClick() {
        this.runAction(async () => {
          try {
            const tenderId = await this.$store.dispatch('createTender');
            this.$router.push({ name: 'purchases-tender-details', params: { tenderId, tab: 'overview' } });
          }
          catch(e) {
            console.error('unable to create lot state', e);
            this.globalErrorHandler(e);
          }
        });
      },

      resetFilters() {
        Object.assign(this.$data, this.$options.data.apply(this));
      }
    }
  }
</script>

<style scoped>

</style>
